export const StrategyManage = {
  circle: async () => (await import('./CircleBubble')).default,
}